import React, { Fragment } from 'react'

import PermitForm from '../../forms/PermitForm';

import { StudentImmigrationTab } from '../../../../interfaces/student';
import { IPermitDetail } from '../../../../interfaces/services';

interface IPermitProps {
  studentId: number;
  setCurrentTab: (tab: StudentImmigrationTab) => void;
  permits: IPermitDetail[];
}

const Permit = (props: IPermitProps) => {
  const { setCurrentTab, permits, studentId } = props;

  const onGoBack = () => {
    setCurrentTab('Passport');
  };

  const onGoNext = () => {
    setCurrentTab('Visa');
  };

  return (
    <div className='immersion__details_form'>
      <div className="immersion__details_form_inputs__container">
        {permits.map((permit, index) => (
          <Fragment key={index}>
            <PermitForm
              studentId={studentId}
              data={permit}
            />

            {index < permits.length - 1 && (
              <Fragment>
                <div className="immersion__details_form_inputs__container__divider" />
                <br />
                <br />
              </Fragment>
            )}

          </Fragment>
        ))}
      </div>

      <div className="immersion__details_form_actions">
        <button
          className={`immersion__btn immersion__btn__secondary`}
          onClick={onGoBack}
        >
          Go back
        </button>

        <button
          className={`immersion__btn immersion__btn__primary`}
          onClick={onGoNext}
        >
          Next
        </button>
      </div>
    </div>
  )
}

export default Permit;